import { axiosInstance } from '../Config/axios';

const API_URL = 'v1/dashboards/';
const API_ASSET_FILTER_URL = 'v1/assets-filter/';

const appendArrayParams = (params, key, values) => {
  if (Array.isArray(values)) {
    values.forEach(v => params.append(key, v));
  } else if (values) {
    params.append(key, values);
  }
};

export const getDashboardGeneral = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    appendArrayParams(params, 'assets', filters.asset);
    appendArrayParams(params, 'areas', filters.area);

    const url = `${API_URL}general/${params.toString() ? `?${params.toString()}` : ''}`;

    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error al obtener datos generales del dashboard', error);
    throw error;
  }
};

export const getComplianceLevel = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    appendArrayParams(params, 'assets', filters.asset);
    appendArrayParams(params, 'areas', filters.area);

    const url = `${API_URL}compliance-level-assets/${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los niveles de cumplimiento', error);
    throw error;
  }
};

export const getEvaluationStatus = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    appendArrayParams(params, 'assets', filters.asset);
    appendArrayParams(params, 'areas', filters.area);

    const url = `${API_URL}evaluations-status/${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error al obtener el estado de evaluaciones', error);
    throw error;
  }
};

export const getGapStatus = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    appendArrayParams(params, 'assets', filters.asset);
    appendArrayParams(params, 'areas', filters.area);

    const url = `${API_URL}gaps-status/${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error al obtener el estado de gaps', error);
    throw error;
  }
};

export const getTaskStatus = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    appendArrayParams(params, 'assets', filters.asset);
    appendArrayParams(params, 'areas', filters.area);

    const url = `${API_URL}tasks-status/${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error al obtener el estado de tareas', error);
    throw error;
  }
};

export const getControlStatus = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    appendArrayParams(params, 'assets', filters.asset);
    appendArrayParams(params, 'areas', filters.area);

    const url = `${API_URL}controls-status/${params.toString() ? `?${params.toString()}` : ''}`;

    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los estados de los controles', error);
    throw error;
  }
};

// Función para listar los filtros disponibles para el dashboard
export const getAssetsFilter = async () => {
  try {
    const response = await axiosInstance.get(API_ASSET_FILTER_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los filtros de activos:', error);
    throw error;
  }       
};